import { useNavigate } from 'react-router-dom';
import { ShieldX } from 'lucide-react';
import { Button } from '@/components/ui/Button';
import { AppRoutes } from '@/constants/routes';

export const AccessDeniedPage = () => {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4">
      <div className="w-20 h-20 rounded-full bg-red-50 dark:bg-red-900/20 flex items-center justify-center mb-6">
        <ShieldX size={36} className="text-red-500" />
      </div>
      <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
        Access Denied
      </h1>
      <p className="text-sm text-gray-500 dark:text-gray-400 mb-8 max-w-sm">
        You don't have the required permissions to view this page.
        Contact your administrator if you believe this is a mistake.
      </p>
      <Button onClick={() => navigate(AppRoutes.DASHBOARD)}>
        Back to Dashboard
      </Button>
    </div>
  );
};
